import React from 'react';
import styled from 'styled-components';

const OfflineAlertDialog = () => {
  const DialogWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;
  const DialogContent = styled.div`
  background: #fff;
  padding: 10px;
  border-radius: 16px;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.3);
  width: 600px;
  text-align: center;
  position: relative;
  font-family: 'Arial', sans-serif;
  color: #000;
`;
  return (
    <DialogWrapper>
      <DialogContent>
        <h2 style={{ marginBottom: '10px', fontSize: '1.5rem', fontWeight: 'bold', marginTop: '10px' }}>
         Offline Submission Not Allowed
        </h2>
        <p style={{ textAlign: 'center', marginBottom: '10px', fontSize: '1rem' }}>
          Not able to submit your data while offline. Please connect to the internet to continue.
        </p>
      </DialogContent>
    </DialogWrapper>
  );
};
export default OfflineAlertDialog;
